import React from 'react';
import './input-select.css'
import pic27 from '../../assets/pic27.png'
import { useEffect } from 'react';
import { useState } from 'react';
import { useRef } from 'react';


const Inputselect = (props) => {

   const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const selectRef = useRef();

  useEffect(() => {
    setSelected(props.value || null);}, [props.value]);

  const handleSelect = (item) => {
    setSelected(item);
    setIsOpen(false);props.onChange && props.onChange(item); };

  const getLabel = (item) => {
    if (typeof item === "object" && item !== null) {
      return item.name || item.label;}
    return item;};

    return (  
 <fieldset className="custom-select-container" ref={selectRef}>

      <label className="title-inputt">
        {props.label}
      </label>

      <fieldset 
        className={`select-box ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
       <span>{selected ? getLabel(selected) : props.placeholder}</span>

        <img 
          src={pic27} className={`arrow ${isOpen ? 'open' : ''}`}  alt='dropdown icon' />
      </fieldset>

        {isOpen && (
        <fieldset className="dropdown">
          {props.options?.map((item, index) => (
            <fieldset key={index} className="dropdown-item" onClick={() => handleSelect(item)}>
                {typeof item === "object"
                  ? `${item.name ?? ""}${item.price ? ` - ${item.price} EGP` : ""}`
                  : item}
            </fieldset>
          ))}
      </fieldset>)}

    </fieldset>
    );
}
 
export default Inputselect;